<template>
    <div class="row layer-featureable-gallery">
        <div class="col-12">
            <template v-if="textHeader">
                <div class="row">
                    <div class="col-12 d-flex align-items-center">
                        <i v-if="iconHeader" class="mr-2" :class="iconHeader"></i>
                        <span class="header">{{ textHeader }}</span>
                    </div>
                </div>
                <hr class="mt-0">
            </template>

            <div class="row">
                <div class="col-12 px-0">
                    <LayerFeatureableGroup
                        :cardGroupClass="cardGroupClass"
                        v-for="(group, index) in groups"
                        :key="`layer-featureable-group-${index}`"
                        :entity="group.entity"
                        :items="group.features"
                        :translateID="translateID"
                        @selected="onSelected"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mixins: [
        ],
        components:{
            LayerFeatureableGroup: () => import(/* webpackChunkName: "recursive-details-layer-featureablegroup" */ './LayerFeatureableGroup'),
        },
        props: {
            translateID: {
                type: String,
                default: 'featureable',
            },
            iconHeader: {
                type: String,
                default: 'fas fa-location-dot',
            },
            textHeader: {
                type: String,
                default: null,
            },
            groups: {
                type: Array,
                default: () => {
                    return []
                },
            },
            cardGroupClass: {
                type: String,
                default: 'card-columns',
            },
        },
        data() {
            return {
            }
        },
        computed: {
        },
        methods: {
            onSelected(params) {
                this.$emit('selected', params);
            }
        },
        watch: {
        },
    }
</script>

<style lang="scss">
@import "@styles/bootstrap/_mixins.scss";
.layer-featureable-gallery {
    width: 100%;
    margin-right: 0;
    margin-left: 0;

    @include media-breakpoint-down(xs) {
        >.col,
        >[class*=col-] {
            padding-left: 0;
            padding-right: 0;
        }
    }


    .header {
        @include font-size(1.25rem);
        font-family: var(--city-bold-font-family);
    }
}

</style>